import { render, staticRenderFns } from "./5ALevel.vue?vue&type=template&id=5d46b6bc&scoped=true"
import script from "./5ALevel.vue?vue&type=script&lang=js"
export * from "./5ALevel.vue?vue&type=script&lang=js"
import style0 from "./5ALevel.vue?vue&type=style&index=0&id=5d46b6bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46b6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d46b6bc')) {
      api.createRecord('5d46b6bc', component.options)
    } else {
      api.reload('5d46b6bc', component.options)
    }
    module.hot.accept("./5ALevel.vue?vue&type=template&id=5d46b6bc&scoped=true", function () {
      api.rerender('5d46b6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/5ALevel.vue"
export default component.exports